export enum UserType {
  Influencer = 'influencer',
  Agency = 'agency',
}
